module.exports = __webpack_public_path__ + "img/lose_lottery2_small.53a28c8f.png";